import { Injectable } from '@angular/core';
import { DataService } from '../common/data.service';
import { Router } from '@angular/router';

@Injectable({
     providedIn: 'root'
})
export class CommonService {

     constructor(private _data: DataService, private _router: Router) { }

     /***********************************Method Section************************************/
     Autocomplete(url, keyword) {
          return this._data.PostData(url, { Param1: keyword, Param2: null });
     }

     BindDropDown(DropDownName) {
          return this._data.PostData('FillCommonData/GetDropdownList', { Param1: DropDownName });
     }

     BindDropDownWithParam(DropDownName, Param = null, Param1 = null) {
          return this._data.PostData('FillCommonData/GetDropdownList', { Param1: DropDownName, Param2: Param, Param3: Param1 });
     }

     GetAuditTrails = (id: string, className: string): any => {
          if (id != null) {
               return this._data.GetData('FillCommonData/GetAuditTrails/' + id + '/' + className);
          } else {
          }
     }

     GetNumbersList = (count) => {
          return this._data.GetData('FillCommonData/GetNumbersList/' + count);
     }

     GetLocationList(userRole) {
          if (userRole != null) {
               return this._data.GetData('FillCommonData/GetRoleWiseLocation/' + userRole);
          }
     }

     UpdateSecurityConsent() {
          return this._data.PostData('FillCommonData/SecurityConsent/', null);
     }
     /**************************************Section End***********************************/

     /*******************************************Global Function**************************/
     Exit() {
          if (confirm('Are you sure to exit?')) {
              this._router.navigate(['dashboard']);
          }
      }
     /*******************************************End Function*****************************/
}


